import {FC} from "react";
import {Card, Col, Table} from "react-bootstrap";
import useCumulativeInvoice from "@oldDashboard/legacyHooks/useCumulativeInvoice";
import Loader from "@/components/common/loader/loader";
import { moneyFormat } from "@oldDashboard/legacyUtils";
import { CumulativeInvoice } from "@oldDashboard/legacyModels/cumulativeInvoice";

interface CumulativeInvoiceTile { data: CumulativeInvoice, launchSelected: String, timePeriodSelected: String, searching: boolean }
const CumulativeInvoiceTile: FC<CumulativeInvoiceTile> = ({ data, launchSelected, timePeriodSelected, searching}) => {
    
    const { isLoading } = useCumulativeInvoice({launchSelected, timePeriodSelected, searching});
    if(!data.visible) return null;
    
    return (
        <Col xxl={3} xl={6} lg={6} md={12} sm={12}>
            <Card className="custom-card overflow-hidden pb-2" style={{height: '250px'}}>
                {isLoading && <Loader/> }
                <Card.Body>
                    <div className="h-100">
                        <Table className="h-100 table overflow-hidden">
                            <thead style={{height:'80%'}}>
                                <tr>
                                    <th>
                                        <div className="d-flex flex-column align-items-center text-center">
                                            <h5 className="fw-semibold mb-2">Your Estimated Spend to Date</h5>
                                            <span className="fs-36">{moneyFormat(Number(data.y))}</span>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border-0">
                                        <div className="d-flex">
                                            <span className="px-1 my-0">Billing Type: {data.billingType}&nbsp;&nbsp;</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody> 
                        </Table>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default CumulativeInvoiceTile;
